import firebase from 'firebase/app';

export const reduceTokens = (auth, tokens, teamToken, tokensTeam) => {

    if(!teamToken?.[0]?.teamToken){
        var sum = Number(tokens.totalTokens) - 1

        firebase.firestore()
                    .collection('customers')
                    .doc(auth.uid)
                    .collection('tokens')
                    .doc(auth.uid)
                    .update({
                        totalTokens: sum
                    })
                    .catch(function (error) {
                        console.error('Error adding document: ', error);
                    });
                    //console.log('auth');
    }else{
        sum = Number(tokensTeam) - 1

        firebase.firestore()
                    .collection('customers')
                    .doc(teamToken?.[0]?.adminId)
                    .collection('tokens')
                    .doc(teamToken?.[0]?.adminId)
                    .update({
                        totalTokens: sum
                    })
                    .catch(function (error) {
                        console.error('Error adding document: ', error);
                    });
                    //console.log('admin');
    }
}
